import React from 'react'
import { Modal } from 'react-bootstrap'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'

const PopoutIframeModal = ({ title, link, appleUrl, closeModal, createUserEvent, show, language, onHide }) => {
  const translated = messages[language]

  if (appleUrl && show) {
    window.open(link)
    closeModal()
    return null
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      bsSize="large"
      dialogClassName="db-font-override"
    >
      <Modal.Header closeButton>
        <Modal.Title
          componentClass="h2"
          id="contained-modal-title-sm"
          style={{ fontSize: '1.6em' }}
        >
          {title}
          <br />
          <a
            style={{ fontSize: '.8em' }}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              createUserEvent({
                category: 'specs',
                data: { action: 'NewTabUserManual' }
              })
            }
          >
            {translated.tab}
          </a>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <iframe
          style={{ width: '100%', minHeight: '500px' }}
          src={link}
          title="Modal-body"
        />
      </Modal.Body>
    </Modal>
  )
}

export default LanguageProvider(PopoutIframeModal)



// WEBPACK FOOTER //
// ./src/components/PopoutIframeModal/PopoutIframeModal.js